export default __webpack_public_path__ + "static/media/03_DAIF_Eco_03_INTEL_end.0ad4ab3d.jpg";